import {createSelector} from 'reselect';

// Delivery Notes Stats redux state
const deliveryNotesStatsReducerSelector = state => state.deliveryNotesStats;

// Delivery Notes Stats List
const deliveryNotesStatsSelector = createSelector(
    deliveryNotesStatsReducerSelector,
    deliveryNotesStatsReducer => deliveryNotesStatsReducer.get('payload')
);

// Delivery Notes Stats is fetching
const deliveryNotesStatsIsFetchingSelector = createSelector(
    deliveryNotesStatsReducerSelector,
    deliveryNotesStatsReducer => deliveryNotesStatsReducer.get('isFetching')
);

// Delivery Notes Stats error
const deliveryNotesStatsErrorSelector = createSelector(
    deliveryNotesStatsReducerSelector,
    deliveryNotesStatsReducer => deliveryNotesStatsReducer.get('error')
);

export {
    deliveryNotesStatsSelector,
    deliveryNotesStatsIsFetchingSelector,
    deliveryNotesStatsErrorSelector
};